import {RadioField} from '@/components/commons/radio-field/RadioField'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Label} from '@/components/ui/label/Label'
import {ChangeEventHandler} from 'react'
import {FieldError} from 'react-hook-form'
import {ObjectKeys} from '@/utilities/helpers'
import {patientDisabilitiesToLabel} from '@/features/patients/utils'
import {useTranslation} from '@/translations/i18n'

interface PatientDisabilitiesRadioButtonsProps {
    name: string
    value: string
    label: string
    onChange: ChangeEventHandler<HTMLInputElement>
    error?: FieldError
}

export const PatientDisabilitiesRadioButtons = ({
    name,
    value,
    label,
    onChange,
    error
}: PatientDisabilitiesRadioButtonsProps) => {
    const {t} = useTranslation()

    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{label}</Label>
            <Flexbox fullWidth direction="column" gap={1.5}>
                <Grid columns={3} gap={4} fullWidth>
                    {ObjectKeys(patientDisabilitiesToLabel).map(patientDisabilityKey => (
                        <FormFieldBox
                            key={patientDisabilityKey}
                            spanColumn={1}
                            isSelected={value == patientDisabilityKey}
                            hasError={!!error}
                        >
                            <RadioField
                                label={t(patientDisabilitiesToLabel[patientDisabilityKey])}
                                name={name}
                                checked={value == patientDisabilityKey}
                                onChange={onChange}
                                value={patientDisabilityKey}
                            />
                        </FormFieldBox>
                    ))}
                </Grid>
                {error?.message && <InputHelpText error={error.message} />}
            </Flexbox>
        </Flexbox>
    )
}
